import contextsJson from '../data/helpContexts.json';
import faqsJson from '../data/helpFaqs.json';
import type { HelpContext, HelpFaq } from './types';

const STATUSES = new Set(['draft', 'published']);
const CTA_ACTIONS = new Set(['navigate', 'open_context', 'contact']);

export function validateHelpData(contexts: HelpContext[], faqs: HelpFaq[]): string[] {
  const problems: string[] = [];
  const keys = new Set<string>();

  for (const ctx of contexts) {
    if (keys.has(ctx.key)) problems.push(`duplicate context key ${ctx.key}`);
    keys.add(ctx.key);
  }
  if (!keys.has('global')) problems.push('missing the global context');

  for (const ctx of contexts) {
    if (ctx.key === 'global') {
      if (ctx.parent !== null) problems.push('global must have parent null');
    } else {
      if (!ctx.parent || !keys.has(ctx.parent)) problems.push(`context ${ctx.key} has unknown parent ${ctx.parent}`);
      if (!ctx.label) problems.push(`context ${ctx.key} has no label`);
    }
    if (ctx.guide?.actions && ctx.guide.actions.length !== 3) {
      problems.push(`context ${ctx.key} guide must have exactly three actions`);
    }
  }

  const ids = new Set<string>();
  for (const faq of faqs) {
    if (ids.has(faq.id)) problems.push(`duplicate faq id ${faq.id}`);
    ids.add(faq.id);
    if (!keys.has(faq.context_key)) problems.push(`faq ${faq.id} references unknown context ${faq.context_key}`);
    if (!faq.question.trim()) problems.push(`faq ${faq.id} has an empty question`);
    if (!faq.answer_md.trim()) problems.push(`faq ${faq.id} has an empty answer`);
    if (!STATUSES.has(faq.status)) problems.push(`faq ${faq.id} has invalid status ${faq.status}`);
    if (!Array.isArray(faq.tags)) problems.push(`faq ${faq.id} tags must be an array`);
    if (faq.cta) {
      if (!CTA_ACTIONS.has(faq.cta.action)) problems.push(`faq ${faq.id} has invalid cta action ${faq.cta.action}`);
      if (faq.cta.action !== 'contact' && !faq.cta.target) problems.push(`faq ${faq.id} cta needs a target`);
      if (faq.cta.action === 'open_context' && faq.cta.target && !keys.has(faq.cta.target)) {
        problems.push(`faq ${faq.id} cta targets unknown context ${faq.cta.target}`);
      }
    }
  }
  return problems;
}

export const HELP_CONTEXTS = contextsJson as HelpContext[];
export const HELP_FAQS = faqsJson as HelpFaq[];

const problems = validateHelpData(HELP_CONTEXTS, HELP_FAQS);
if (problems.length > 0) {
  throw new Error(`Invalid help data:\n${problems.join('\n')}`);
}
